import { UiVaultConfig } from 'src/@types/vaults';
import { Warning } from '@velocity-exchange/icons';
import Tooltip from 'src/components/primitives/Tooltip/Tooltip';
import { FeeChangeMessageContent } from './FeeChanges';
import Tag from '../primitives/Tag/Tag';
import dayjs from 'dayjs';
import PresetTag from 'src/components/Tags/PresetTag';

export const VaultTags = (props: {
	uiVaultConfig: UiVaultConfig;
	numOfVaultSnapshots: number;
	excludeName?: boolean;
}) => {
	const isNew = props.uiVaultConfig.isNew(props.numOfVaultSnapshots);
	const isHighRisk = props.uiVaultConfig.isHighRisk;

	const isDeprecating = props.uiVaultConfig.isDeprecating;
	const isDeprecated = props.uiVaultConfig.isDeprecated;

	const hasFeeChangesToWarnAbout =
		props.uiVaultConfig.feeChangesToAlert?.length > 0;

	return (
		<div className="flex flex-col items-start justify-center gap-y-xs">
			<div className="flex flex-wrap items-center gap-xs">
				{!props.excludeName && (
					<Tag variant="neutral">{props.uiVaultConfig.vaultManager.name}</Tag>
				)}
				{isNew && <PresetTag preset="new" />}
				{isHighRisk && (
					<Tag variant="warning" rightIcon={Warning}>
						High Risk
					</Tag>
				)}
				{isDeprecating && (
					<Tooltip
						decoration="none"
						content={`This vault is ${
							isDeprecated ? 'deprecated' : 'soon to be deprecated'
						} and ${
							isDeprecated ? 'stopped trading' : 'will stop trading'
						} on ${dayjs(props.uiVaultConfig.deprecationDateTs).format(
							'MMM D, YYYY'
						)}. Please withdraw your funds.`}
					>
						<Tag variant="danger" rightIcon={Warning}>
							{isDeprecated ? 'Deprecated' : 'Deprecating'}
						</Tag>
					</Tooltip>
				)}
				{hasFeeChangesToWarnAbout && (
					<Tooltip
						decoration="none"
						content={
							<FeeChangeMessageContent vaultConfig={props.uiVaultConfig} />
						}
					>
						<Tag variant="warning" rightIcon={Warning}>
							Fee Update
						</Tag>
					</Tooltip>
				)}
			</div>
		</div>
	);
};
